import { useCallback } from 'react';
import { useStore } from '../store/useStore';
import { translations, Language, Translations } from './translations';

export function useI18n() {
  const { language } = useStore();
  
  const t: Translations = translations[language as Language] || translations.en;
  
  const setLanguage = useCallback((lang: Language) => {
    useStore.getState().setLanguage(lang);
  }, []);
  
  return { t, language: language as Language, setLanguage };
}

export type { Language, Translations };
export { translations };
